module.exports = __webpack_public_path__ + "static/media/CO.08ec96b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CO.svg
// module id = 229
// module chunks = 0